import React, { FC } from 'react';
import TimeInput from 'components/shared/time-input';

type DataTableTimeInputProps = {
    value?: number;
    onChange?: (decimalHours: number | undefined) => void;
    onValidChange?: (isValid: boolean) => void;
    onBlur?: () => void;
    disabled?: boolean;
};

const DataTableTimeInput: FC<DataTableTimeInputProps> = ({ value, onChange, onValidChange, onBlur, disabled }) => {
    return (
        <TimeInput
            value={value}
            onChange={onChange}
            onValidChange={onValidChange}
            onBlur={onBlur}
            disabled={disabled}
            variant="standard"
            fullWidth
            autoComplete="off"
            InputProps={{ disableUnderline: true }}
            inputProps={{ autoComplete: 'off' }}
            sx={{
                marginTop: '0 !important',
                marginBottom: '0 !important',
                '& .MuiInputBase-root': {
                    padding: 0,
                    fontSize: '0.9rem',
                },
                '& .MuiInputBase-input': {
                    padding: '4px 8px',
                },
            }}
        />
    );
};

export default DataTableTimeInput;
